import { render, staticRenderFns } from "./OpenVPNClientList.vue?vue&type=template&id=e629a506&"
import script from "./OpenVPNClientList.vue?vue&type=script&lang=js&"
export * from "./OpenVPNClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports